import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {isNullOrUndefined} from 'util';
import {Logger} from '../utils/Logger';
import { ConfigService } from '../service/config.service';
import { ReferralSchemeDateRange } from '../model/referral-schmem-date.model';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit, AfterViewInit {
    Tabs = Tabs;
    selectedTab = Tabs.BORROWER;
    raferralDate: ReferralSchemeDateRange;
    preferenceType: 'nCash' | 'swift' = null;
    liquidityCase: string = null;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.raferralDate = ConfigService.referralSchemeDateRange();
        this.processSelectedTabParameter(this.route.snapshot.queryParams['selectedTab']);
        this.preferenceType = this.route.snapshot.queryParams['preferenceType'];
        this.liquidityCase = this.route.snapshot.queryParams['liquidityCase'];
    }

    ngAfterViewInit() {
        if(this.selectedTab == Tabs.FINZY_FLEX) {
            if(this.preferenceType == "swift")
                this.scroll("swift");
            else if(this.preferenceType == "nCash")
                this.scroll("nCash");
            if (this.liquidityCase == "liquidity")
                this.scroll("liquidity")
        }
    }

    scroll(id) {
        setTimeout(function() {
            let el = document.getElementById(id);
            el.scrollIntoView({block: 'start'});
            window.scrollBy(0, -80);
        }, 50);
    }

    processSelectedTabParameter(selectedTab: string) {
        Logger.log('Selected Tab parameter: ' + selectedTab);
        if (isNullOrUndefined(selectedTab)) {
            this.selectedTab = Tabs.BORROWER;
        } else {
            selectedTab = selectedTab.toUpperCase();
            switch (selectedTab) {
                case 'BORROWER':
                    this.selectedTab = Tabs.BORROWER;
                    break;
                case 'INVESTOR':
                    this.selectedTab = Tabs.INVESTOR;
                    break;
                case 'FINZY_PRO':
                    this.selectedTab = Tabs.FINZY_PRO;
                    break;
                case 'REINVEST':
                    this.selectedTab = Tabs.REINVEST;
                    break;
                case 'PRICING':
                    this.selectedTab = Tabs.PRICING;
                    break;
                case 'REFERRAL':
                    this.selectedTab = Tabs.REFERRAL;
                    break;
                case 'FINZY_BOLT':
                    this.selectedTab = Tabs.FINZY_BOLT;
                    break;
                case 'FINZY_FLEX':
                    this.selectedTab = Tabs.FINZY_FLEX;
                    break;
                default:
                    this.selectedTab = Tabs.BORROWER;
                    break;
            }
        }
    }
}

enum Tabs {
    BORROWER = 'BORROWER',
    INVESTOR = 'INVESTOR',
    FINZY_PRO = 'FINZY_PRO',
    REINVEST = 'REINVEST',
    PRICING = 'PRICING',
    REFERRAL = 'REFERRAL',
    FINZY_BOLT = 'FINZY_BOLT',
    FINZY_FLEX = 'FINZY_FLEX'
}
